module.exports = __webpack_public_path__ + "static/media/111.10fb010b.png";